import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { VSBuffer } from 'vscode/vscode/vs/base/common/buffer';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { getMediaOrTextMime } from 'vscode/vscode/vs/base/common/mime';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { FileOperationError } from 'vscode/vscode/vs/platform/files/common/files';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';

let BrowserRemoteResourceLoader = class BrowserRemoteResourceLoader extends Disposable {
    constructor(fileService, provider) {
        super();
        this.provider = provider;
        this._register(provider.onDidReceiveRequest(async (request) => {
            let uri;
            try {
                uri = JSON.parse(decodeURIComponent(request.uri.query));
            }
            catch {
                return request.respondWith(404, ( new Uint8Array()), {});
            }
            let content;
            try {
                content = await fileService.readFile(( URI.from(uri, true)));
            }
            catch (e) {
                const str = VSBuffer.fromString(e.message).buffer;
                if (e instanceof FileOperationError && e.fileOperationResult === 1 ) {
                    return request.respondWith(404, str, {});
                }
                else {
                    return request.respondWith(500, str, {});
                }
            }
            const mime = uri.path && getMediaOrTextMime(uri.path);
            request.respondWith(200, content.value.buffer, mime ? { 'content-type': mime } : {});
        }));
    }
    getResourceUriProvider() {
        const baseUri = ( URI.parse(document.location.href));
        return uri => baseUri.with({
            path: this.provider.path,
            query: JSON.stringify(uri),
        });
    }
};
BrowserRemoteResourceLoader = ( __decorate([
    ( __param(0, IFileService))
], BrowserRemoteResourceLoader));

export { BrowserRemoteResourceLoader };
